import script from "./ShowMonitoraggioPuntuale.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowMonitoraggioPuntuale.vue?vue&type=script&setup=true&lang=js"

import "./ShowMonitoraggioPuntuale.vue?vue&type=style&index=0&id=bbc7b290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbc7b290"]])

export default __exports__